<template>
  <div class="article-detail" v-loading="loading">
    <div class="article-top clear">
      <el-button
        size="mini"
        round
        icon="el-icon-arrow-left"
        class="back ml15"
        plain
        @click="back"
        >返回列表</el-button
      >
      <el-button
        size="mini"
        round
        plain
        class="fr mr15 full"
        @click="full(item.guid)"
        >引用全文</el-button
      >

      <el-button
        size="mini"
        round
        plain
        class="fr yinyong"
        @click="introduce(item.guid)"
        v-if="type !== 'paragraph' && type !== 'collectParagraph'"
        >引用精华</el-button
      >

      <!-- <el-divider></el-divider> -->
    </div>
    <div>
      <h3 class="title ml15">
        {{ item.title }}
      </h3>
      <div class="tips ml15">
        <div v-if="type === 'detail' || type === 'hotBd'">
          <el-avatar
            class="avatar"
            :size="15"
            :src="item.headImage"
          ></el-avatar>
          <span class>{{ item.name }}</span>
          <span class>|</span>
          <span class>{{ item.issueTime | changeTime() }}</span>
          <!--          <span class>|</span>-->
          <!--          <span class="read"-->
          <!--            >阅读{{ item.readCount > 0 ? item.readCount : 0 }}</span-->
          <!--          >-->
          <span class>|</span>
          <el-avatar
            class="avatar"
            :size="15"
            :src="getIcon(item.resourcePlatformName)"
          ></el-avatar>
          <span>{{ item.resourcePlatformName }}</span>
        </div>
        <div v-else-if="type === 'paragraph'">
          <span class>{{ item.issueTime | dateformat("YYYY-MM-DD") }}</span>
          <el-avatar
            class="avatar"
            :size="15"
            :src="getIcon(item.resourcePlatformName)"
          ></el-avatar>
          <span>{{ item.resourcePlatformName }}</span>
        </div>
        <div v-else style="width: 100%;">
          <span>创建时间：{{ item.issueTime }}</span>
          <span v-if="type === 'paragraph'">更新时间：{{ item.addTime }}</span>
          <span style="float: right" v-if="item.setTopTime"
            ><i class="icons top"></i>置顶</span
          >
        </div>
      </div>
      <div
        v-if="type === 'doc'"
        class="article-content ml15"
        v-html="item.content"
        ref="articlecontent"
        id="article-detail-data-content"
      ></div>
      <div
        v-else
        id="article-detail-data-content"
        class="article-content ml15"
        ref="articlecontent"
        v-html="item.articleContent"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { init } from "../../assets/script/utils/mouse";
import editorControl from "../../assets/script/utils/editorControl";
import config from "../../assets/script/config/index.js";
export default {
  data() {
    return {
      item: [],
      popoverVisible: false,
      guid: this.$route.params.guid,
      loading: false,
      type: this.$route.params.type,
      topNumber: this.$route.params.type === "doc" ? 5 : -10
    };
  },
  computed: {
    ...mapState("user", ["userToken", "userLevel"]),
    ...mapState("material", ["useGuid"]),
    insertHtml: {
      get() {
        return this.$store.state.editorControl.insertHtml;
      },
      set(val) {
        this.$store.state.editorControl.insertHtml = val;
      }
    },
    wycContent: {
      get() {
        return this.$store.state.wycContent.wycContent;
      },
      set(val) {
        this.$store.state.wycContent.wycContent = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      }
    },
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "article-content", this.topNumber, "class");
      }
    }
  },
  methods: {
    ...mapActions("api", [
      "AActicledetail",
      "ADocDetail",
      "AParagraphResource"
    ]),
    ...mapActions("material", [
      "AFavoriteResourcesDetail",
      "AFavoriteParagraphDetail",
      "ADataQuoteInsert"
    ]),
    ...mapActions("hotList", ["AHotRankDetail"]),
    ...mapMutations("material", ["ASetUseGuid"]),
    ...mapActions("sucaiSearch", ["AAbstract"]),
    back() {
      // this.setActicledetail("");
      this.$router.back(-1);
    },
    async addQuoteInsert(resourceGuid) {
      if (this.userToken === "") return;
      let dataInfo = { dataString: resourceGuid, dataType: "resource" };
      let result = await this.ADataQuoteInsert(dataInfo);
      if (result.errorCode > 0) {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      } else {
        this.ASetUseGuid(resourceGuid);
      }
    },
    full(resourceGuid) {
      let content = "";
      if (this.type === "doc") {
        content = this.item.content;
      } else {
        content = this.item.articleContent;
      }
      this.wycShow
        ? editorControl.setWycContent(content, "文章全文引入成功")
        : editorControl.setAllInnerTxt(content, "文章全文引入成功");
      this.addQuoteInsert(resourceGuid);
    },
    async introduce(resourceGuid) {
      // if (this.userLevel >= 100) {
      let intro = this.item.intro;
      var abstractResult = await this.AAbstract({
        articleContent: this.item.articleContent
      });
      if (abstractResult.errorCode === 0 && abstractResult.data) {
        intro = abstractResult.data;
      } else {
        if (intro === "") {
          intro = this.item.intro2;
        }
      }
      if (intro === "") {
        this.$message({
          message: "该文章未发现精华内容",
          type: "warning"
        });
        return;
      }
      this.wycShow
        ? editorControl.setWycContent(intro, "文章精华插入成功")
        : editorControl.setInnerTxt(intro, "文章精华插入成功");
      //使用记录
      this.addQuoteInsert(resourceGuid);
      // } else {
      //   this.insertConfig.showUpgrade(true, "升级获得使用权");
      // }
    },
    getIcon(resourcePlatformName) {
      if (
        resourcePlatformName === "今日头条" ||
        resourcePlatformName === "头条"
      ) {
        return require("../../assets/image/icon/tt.png");
      } else if (resourcePlatformName === "知乎") {
        return require("../../assets/image/icon/zh.png");
      } else if (resourcePlatformName === "微信") {
        return require("../../assets/image/icon/wx.png");
      } else if (resourcePlatformName === "全网采集") {
        return require("../../assets/image/icon/qwcj.png");
      } else if (resourcePlatformName === "新浪网") {
        return require("../../assets/image/hot/sina_ico.png");
      } else if (resourcePlatformName === "网易") {
        return require("../../assets/image/hot/wangyi_ico.png");
      } else if (resourcePlatformName === "简书") {
        return require("../../assets/image/hot/jianshu_ico.png");
      } else if (resourcePlatformName === "百度热搜") {
        return require("../../assets/image/hot/baidu_ico.png");
      } else if (resourcePlatformName === "历史上的今天") {
        return require("../../assets/image/hot/htody_ico.png");
      } else if (resourcePlatformName === "网易") {
        return require("../../assets/image/icon/wangyi.png");
      } else if (resourcePlatformName === "新浪网") {
        return require("../../assets/image/icon/sina.png");
      } else if (resourcePlatformName === "简书") {
        return require("../../assets/image/icon/jianshu.png");
      } else if (resourcePlatformName === "凤凰网") {
        return require("../../assets/image/icon/ifeng.png");
      } else if (resourcePlatformName === "搜狐") {
        return require("../../assets/image/icon/sohu.png");
      }
    },
    async getDetail() {
      this.loading = true;
      let result = null;
      if (this.type === "doc") {
        result = await this.ADocDetail({ docId: this.guid });
      } else if (this.type === "paragraph") {
        result = await this.AParagraphResource({ resourceGuid: this.guid });
      } else if (this.type === "collectParagraph") {
        result = await this.AFavoriteParagraphDetail({
          favoriteParagraphId: this.guid
        });
      } else if (this.type === "collect") {
        result = await this.AFavoriteResourcesDetail({
          favoriteResourceId: this.guid
        });
      } else if (this.type === "hotBd") {
        result = await this.AHotRankDetail({ resourceGuid: this.guid });
      } else {
        result = await this.AActicledetail({ resourceGuid: this.guid });
      }
      this.loading = false;
      if (result.errorCode === 0) {
        this.item = result.data;
        if (this.type === "doc") {
          this.item.content = this.filterDetail(this.item.content);
        } else {
          this.item.articleContent = this.filterDetail(
            this.item.articleContent.replace(/<img .*?>/g,'')
          );
        }
      } else {
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
      }

      this.$nextTick(() => {
        try {
          let imgDomList = document
            .getElementsByClassName("article-content")[0]
            .getElementsByTagName("img");
          for (let img of imgDomList) {
            let imgs = new Image();
            if (this.type === "hotBd") {
              imgs.src = img.src.replace(/http:/g, "https:");
              img.src = img.src.replace(/http:/g, "https:");
            } else {
              imgs.src = img.dataset["src"].replace(/http:/g, "https:");
              img.src = img.dataset["src"].replace(/http:/g, "https:");
            }
            imgs.onload = function() {
              imgs.width > 470
                ? (img.style.width = "100%")
                : (img.style.width = "auto");
            };
          }
        } catch (e) {
          // console.log(e);
        }
      });
      let that = this;
      this.$nextTick(() => {
        [].forEach.call(
          that.$refs.articlecontent.getElementsByTagName("img"),
          function(foundImg) {
            if (foundImg.parentNode != null) {
              let foundImgParentNode = foundImg.parentNode;
              let wrapper = document.createElement("div");
              wrapper.className = "__copy_img__";
              wrapper.style.cssText = "position: relative; display: inline-block;";
              foundImgParentNode.insertBefore(wrapper, foundImg);
              wrapper.appendChild(foundImg);


               let aiimage = document.createElement("span");
              aiimage.className = "aiimage-collect-btn";
              aiimage.innerText = "AI配图魔改";
              wrapper.appendChild(aiimage);

               let sendDiv = document.createElement("div");
              sendDiv.className = "search-collect-btn";
              sendDiv.innerText = "引入图片";

              wrapper.appendChild(sendDiv);

              let imageSrc = foundImg.src;
              sendDiv.addEventListener("click", function() {
                that.insertConfig.setInnerPicture(imageSrc, "图片引入成功");
              });
              //  aiimage.addEventListener("click", function() {
              //     window.open(config.www+"/aips?jumpUrl="+imageSrc)
              // });
            }
            //}
          }
        );
      });
    },
    filterDetail(detail) {
      detail = detail.replace(
        '<div class="._5ce-wx-style" style="width:740px">',
        '<div class="._5ce-wx-style" style="width:100%">'
      );
      detail = detail.replace(new RegExp("width: \\d+px;", "gi"), "width:100%");
      // detail = detail.replace(
      //   new RegExp("<img ", "gi"),
      //   '<img style="width:100%"'
      // );
      return detail;
    }
  },
  mounted() {
    init();

    this.fixHeight(this.contentHeight, "article-detail-data-content", 180);
    // let getid = setInterval(() => {
    //   let getBox = document.getElementsByClassName("article-content")[0];
    //   if (getBox) {
    //     clearInterval(getid);
    //     let titleHeight = document.getElementsByClassName("title")[0];
    //     let titleNum = 0;
    //     if (titleHeight) {
    //       titleNum = titleHeight.offsetHeight;
    //       console.log(titleNum);
    //     }
    //     this.getHotLineHeight(
    //       this.contentHeight,
    //       "article-content",
    //       this.topNumber + titleNum,
    //       "class"
    //     );
    //   }
    // }, 500);
  },
  updated() {
    this.fixHeight(this.contentHeight, "article-detail-data-content", 180);
    // let getid = setInterval(() => {
    //   let getBox = document.getElementById("article-detail-data-content");
    //   if (getBox) {
    //     clearInterval(getid);
    //     let titleHeight = document.getElementsByClassName("title")[0];
    //     let titleNum = 0;
    //     if (titleHeight) {
    //       titleNum = titleHeight.offsetHeight;
    //     }
    //     this.getHotLineHeight(
    //       this.contentHeight,
    //       "article-detail-data-content",
    //       this.topNumber + titleNum,
    //       "id"
    //     );
    //   }
    // }, 500);
  },
  activated() {
    this.guid = this.$route.params.guid;
    this.type = this.$route.params.type;
    this.getDetail();

    // let getid = setInterval(() => {
    //   let getBox = document.getElementsByClassName("article-content")[0];
    //   if (getBox) {
    //     clearInterval(getid);
    //     let titleHeight = document.getElementsByClassName("title")[0];
    //     let titleNum = 0;
    //     if (titleHeight) {
    //       titleNum = titleHeight.offsetHeight;
    //     }
    //     this.getHotLineHeight(
    //       this.contentHeight,
    //       "article-content",
    //       this.topNumber + titleNum,
    //       "class"
    //     );
    //   }
    // }, 500);
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
.fullbox {
  width: 100%;
}
.autobox {
  width: auto;
}
//头部
.article-top {
  height: 60px;
  margin-bottom: 15px;
  box-sizing: border-box;
  padding-top: 20px;
  border-bottom: 1px solid #d3d7de;
  width: 480px;
}
.article-top button {
  display: inline-block;
}
.article-top button.back {
  color: #ea8183;
  padding: 7px 10px;
  border-color: #ea8183;
  border: 1px solid;
}
.article-top button.back:hover {
  background-color: @theme-background-color;
}
//标题
.article-detail {
  background-color: @theme-background-color;
  width: 460px;
}
//文章作者，时间等
//tips
.article-detail .tips {
  margin-top: 15px;
  display: flex;
  align-items: center;
  .top {
    /*padding-left: 15px;*/
    background: url("../../assets/image/icon/top.png") no-repeat 0;
  }
}
.icons {
  display: inline-block;
  height: 15px;
  width: 15px;
  vertical-align: text-bottom;
}
.article-detail {
  .full {
    border: 1px solid #dcdfe6;
  }
  .yinyong {
    border: 1px solid #dcdfe6;
  }
  .tips span {
    color: #666666;
    margin-right: 10px;
    font-size: @font-size12;
    vertical-align: bottom;
  }
}
.article-detail .tips .read {
  color: #f48b1e;
}
//文章内容
.article-detail .article-content {
  margin-top: 15px;
  font-size: 14px;
  padding-right: 15px;
  height: 200px;
  width: 100%;
  overflow: auto;
  line-height: 25px;
  overscroll-behavior-y: contain;
  p {
    margin-bottom: 10px;
  }
  /deep/ table {
    border: 1px solid;
    td {
      border: 1px solid;
    }
  }
  /deep/ hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
  }
  /deep/ li {
    list-style: initial !important;
    list-style-type: unset !important;
  }
  /deep/ ol {
    list-style-type: decimal;
  }
  /deep/ ul {
    list-style: disc;
  }
  /deep/.search-collect-btn {
    display: none;
  }
  /deep/.__copy_img__ {
    &:hover {
      .search-collect-btn {
        display: block;
        margin: 0px;
        transition: all 0.1s ease 0s;
        font-weight: 500;
        font-size: 14px;
        background-color: rgb(35, 198, 29);
        border: 1px solid rgb(35, 198, 29);
        color: white;
        border-radius: 20px;
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
      }
    }
  }

  /deep/.aiimage-collect-btn {
    display: none;
  }
  /deep/.__copy_img__ {
    &:hover {
      .aiimage-collect-btn {
        display: block;
        margin: 0px;
        transition: all 0.1s ease 0s;
        font-weight: 500;
        font-size: 14px;
        background-color: rgb(35, 198, 29);
        border: 1px solid rgb(35, 198, 29);
        color: white;
        border-radius: 20px;
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        position: absolute;
        right: 120px;
        top: 5px;
        cursor: pointer;
      }
    }
  }

}
</style>
